import { SERVICES } from "@/lib/brand";
import {
  Music2,
  Mic,
  Disc3,
  Sliders,
  Volume2,
  Cable,
  ArrowUpRight,
} from "lucide-react";

const iconFor = {
  "production-arranging": Music2,
  "live-recordings": Mic,
  "studio-recordings": Disc3,
  "mixing-engineer": Sliders,
  "mastering-engineer": Volume2,
  "audio-engineer": Cable,
};

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-28 lg:py-36 noise"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 mb-16 items-end">
          <div className="lg:col-span-7">
            <p
              data-testid="services-eyebrow"
              className="font-body text-xs uppercase tracking-[0.3em] text-brand-magenta"
            >
              [ Services ]
            </p>
            <h2
              data-testid="services-headline"
              className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-white"
            >
              6 Services But One{" "}
              <span className="text-eq-gradient">Signature Sound</span>.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="font-body text-base text-white/65 leading-relaxed">
              From arranging the first chord to delivering the final master,
              every step is handled in-house with the same attention to
              dynamics, clarity and feel.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = iconFor[s.id] || Music2;
            return (
              <article
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className={`group relative ${s.span ?? "lg:col-span-6"} rounded-3xl border border-white/10 bg-gradient-to-b from-white/[0.04] to-white/[0.01] p-8 lg:p-10 overflow-hidden brand-border-hover transition-all duration-500 hover:-translate-y-1`}
                style={{ animationDelay: `${i * 80}ms` }}
              >
                <div className="flex items-start justify-between gap-6">
                  <div className="h-14 w-14 rounded-2xl bg-white/[0.06] border border-white/10 flex items-center justify-center text-white group-hover:text-brand-magenta transition-colors">
                    <Icon size={26} />
                  </div>
                  <span className="font-body text-xs tracking-[0.2em] text-white/30">
                    0{i + 1}
                  </span>
                </div>

                <h3 className="mt-10 font-display font-extrabold text-2xl lg:text-3xl tracking-tight text-white">
                  {s.title}
                </h3>
                <p className="mt-4 font-body text-sm lg:text-base text-white/60 leading-relaxed max-w-md">
                  {s.blurb}
                </p>

                <a
                  href="#quote"
                  data-testid={`service-cta-${s.id}`}
                  className="mt-8 inline-flex items-center gap-2 font-display font-bold text-sm text-white group-hover:text-brand-orange transition-colors"
                >
                  Book this service
                  <ArrowUpRight
                    size={16}
                    className="group-hover:rotate-45 transition-transform duration-300"
                  />
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
